import React,{useEffect} from "react";
import Swiper from 'swiper';
import { Autoplay, Navigation,Pagination  } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
// import "swiper/css/pagination";
const Testimonialswiper = () => {
    useEffect(() => {
        new Swiper('.qodef-swiper-container', {
            modules: [Autoplay, Navigation,Pagination ],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        //   pagination: {
        //     el: ".swiper-pagination", // Bind pagination
        //     clickable: true, // Allow users to click bullets
        //   },
          loop: true,
          spaceBetween: 30,
          slidesPerView: 1,
          autoplay: {
            delay: 2000, // Slide changes every 3 seconds
            disableOnInteraction: false, // Keeps autoplay running even after user interaction
          },
          speed: 1000,
        });
      }, []);
  return (
    <div
      className="elementor-element elementor-element-b38c90a e-con-full e-flex e-con e-child"
      data-id="b38c90a"
      data-element_type="container"
      data-settings='{"background_background":"classic"}'
    >
      <div
        className="elementor-element elementor-element-2d43a2b elementor-widget elementor-widget-startpro_core_testimonials_list"
        data-id="2d43a2b"
        data-element_type="widget"
        data-widget_type="startpro_core_testimonials_list.default"
      >
        <div className="elementor-widget-container">
          <div
            className="qodef-shortcode qodef-m qodef-testimonials-list qodef-grid qodef-swiper-container qodef-col-num--1 qodef-item-layout--info-below qodef-responsive--predefined qodef-swiper--show-pagination swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden qodef-swiper--initialized"
            data-options='{"spaceBetween":30,"slidesPerView":"1","loop":true,"autoplay":true,"speed":"","speedAnimation":"","slideAnimation":"","direction":"","reverseDirection":false,"centeredSlides":"","sliderScroll":"","loopedSlides":""}'
          >
            <div
              className="swiper-wrapper"
              id="swiper-wrapper-8b3f88dc2c2c9762"
              aria-live="off"
              style={{
                transitionDuration: "0ms", // Duration of the transition
                transform: "translate3d(-2404px, 0px, 0px)", // 3D translation
              }}
            >
              <div
                className="qodef-e swiper-slide swiper-slide-duplicate swiper-slide-next swiper-slide-duplicate-prev"
                // data-swiper-slide-index="2"
                // role="group"
                // aria-label="3 / 3"
                style={{
                  width: "571px", // Set the width of the element
                  marginRight: "30px", // Set the right margin
                }}
              >
                <div className="qodef-e-inner">
                  <div className="qodef-e-content">
                    <p className="qodef-e-text fs-mob">
                    "PMC Oman turned our ambitious infrastructure project into a seamless reality. Their structured approach to feasibility studies and risk management. Their expertise is unmatched.<br/>"
                    </p>
                    <div className="qodef-e-author-info">
                      <div className="qodef-e-media-image">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="128"
                          height="128"
                          src="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img.png"
                          className="attachment-full size-full wp-post-image"
                          alt=""
                          srcset="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img.png 128w, https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img-100x100.png 100w"
                          sizes="(max-width: 128px) 100vw, 128px"
                        />{" "}
                      </div>
                      <h6 className="qodef-e-author">
                        <span className="qodef-e-author-name">
                        Ahmed Al Saadi
                        </span>
                        <span className="qodef-e-author-job">CEO</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="qodef-e swiper-slide swiper-slide-duplicate-active"
                // data-swiper-slide-index="0"
                // role="group"
                // aria-label="1 / 3"
                style={{
                  width: "571px", // Set the width of the element
                  marginRight: "30px", // Set the right margin
                }}
              >
                <div className="qodef-e-inner">
                  <div className="qodef-e-content">
                    <p className="qodef-e-text fs-mob">
                    "We had a stalled commercial project, and PMC Oman’s specialized oversight got it back on track. Their strategic execution ensured a successful completion within our budget."
                    <br/>
                    <br/>
                    </p>
                    <div className="qodef-e-author-info">
                      <div className="qodef-e-media-image">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="128"
                          height="128"
                          src="https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3.png"
                          className="attachment-full size-full wp-post-image"
                          alt="d"
                          srcset="https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3.png 128w, https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3-100x100.png 100w"
                          sizes="(max-width: 128px) 100vw, 128px"
                        />{" "}
                      </div>
                      <h6 className="qodef-e-author">
                        <span className="qodef-e-author-name">
                        Fatima Al Harthy
                        </span>
                        <span className="qodef-e-author-job">Managing Director
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="qodef-e swiper-slide"
                // data-swiper-slide-index="1"
                // role="group"
                // aria-label="2 / 3"
                style={{
                  width: "571px", // Set the width of the element
                  marginRight: "30px", // Set the right margin
                }}
              >
                <div className="qodef-e-inner">
                  <div className="qodef-e-content">
                    <p className="qodef-e-text fs-mob">
                    "The management strategies implemented by PMC Oman significantly optimized our workflow and resource planning. With their expert guidance, we improved efficiency and reduced costs without compromising quality."

                    </p>
                    <div className="qodef-e-author-info">
                      <div className="qodef-e-media-image">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="128"
                          height="128"
                          src="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img2.png"
                          className="attachment-full size-full wp-post-image"
                          alt="d"
                          srcset="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img2.png 128w, https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img2-100x100.png 100w"
                          sizes="(max-width: 128px) 100vw, 128px"
                        />{" "}
                      </div>
                      <h6 className="qodef-e-author">
                        <span className="qodef-e-author-name">
                        Said Al Balushi
                        </span>
                        <span className="qodef-e-author-job">Operations Manager</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="qodef-e swiper-slide swiper-slide-prev swiper-slide-duplicate-next"
                // data-swiper-slide-index="2"
                // role="group"
                // aria-label="3 / 3"
                style={{
                  width: "571px", // Set the width of the element
                  marginRight: "30px", // Set the right margin
                }}
              >
                <div className="qodef-e-inner">
                  <div className="qodef-e-content">
                    <p className="qodef-e-text fs-mob">
                    "PMC Oman’s consultancy services provided us with in-depth market research and financial structuring that enhanced our investment decisions. Their insights were invaluable in shaping our business expansion strategy."
                    </p>
                    <div className="qodef-e-author-info">
                      <div className="qodef-e-media-image">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="128"
                          height="128"
                          src="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img.png"
                          className="attachment-full size-full wp-post-image"
                          alt=""
                          srcset="https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img.png 128w, https://startpro.qodeinteractive.com/wp-content/uploads/2024/10/testimonials-img-100x100.png 100w"
                          sizes="(max-width: 128px) 100vw, 128px"
                        />{" "}
                      </div>
                      <h6 className="qodef-e-author">
                        <span className="qodef-e-author-name">
                        Nasser Al Riyami
                        </span>
                        <span className="qodef-e-author-job">CFO</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="qodef-e swiper-slide swiper-slide-duplicate swiper-slide-active"
                // data-swiper-slide-index="0"
                // role="group"
                // aria-label="1 / 3"
                style={{
                  width: "571px", // Set the width of the element
                  marginRight: "30px", // Set the right margin
                }}
              >
                <div className="qodef-e-inner">
                  <div className="qodef-e-content">
                    <p className="qodef-e-text fs-mob">
                    "PMC Oman’s consultancy services provided us with in-depth market research and financial structuring that enhanced our investment decisions. Their insights were invaluable in shaping our business expansion strategy."

                    </p>
                    <div className="qodef-e-author-info">
                      <div className="qodef-e-media-image">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="128"
                          height="128"
                          src="https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3.png"
                          className="attachment-full size-full wp-post-image"
                          alt="d"
                          srcset="https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3.png 128w, https://startpro.qodeinteractive.com/wp-content/uploads/2024/11/testimonials-img3-100x100.png 100w"
                          sizes="(max-width: 128px) 100vw, 128px"
                        />{" "}
                      </div>
                      <h6 className="qodef-e-author">
                        <span className="qodef-e-author-name">
                        Nasser Al Riyami
                        </span>
                        <span className="qodef-e-author-job">CFO</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="qodef-navigation-holder">
              <div
                className="swiper-button-prev "
              
                role="button"
                aria-label="Previous slide"
                aria-controls="swiper-wrapper-8b3f88dc2c2c9762"
              >
                <svg
                  className="qodef-svg--slider-arrow-left"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.162 19.162"
                >
                  <g fill="none" stroke="currentColor">
                    <path d="M9.934.355.707 9.583l9.227 9.227"></path>
                    <path d="M.707 9.582h18.455"></path>
                  </g>
                </svg>
              </div>
              <div
                className="swiper-button-next "
             
                role="button"
                aria-label="Next slide"
                aria-controls="swiper-wrapper-8b3f88dc2c2c9762"
              >
                <svg
                  className="qodef-svg--slider-arrow-right"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 19.162 19.162"
                >
                  <g fill="none" stroke="currentColor">
                    <path d="m9.228.353 9.227 9.227-9.227 9.228"></path>
                    <path d="M18.455 9.58H0"></path>
                  </g>
                </svg>
              </div>
              <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                <span
                  className="swiper-pagination-bullet swiper-pagination-bullet-active"
                
                  aria-current="true"
                >
                  1
                </span>
                <span className="swiper-pagination-bullet" >
                  2
                </span>
                <span className="swiper-pagination-bullet" >
                  3
                </span>
              </div>
            </div>
            <span
              className="swiper-notification"
              aria-live="assertive"
              aria-atomic="true"
            ></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonialswiper;
